import React from 'react';
import { Box, Typography } from '@mui/material';
import AudioPlayerCard from './audioplayer';

const Inicio = () => (
  <Box id="inicio" sx={{ py: 5, px: 2 }}>
    <Typography variant="h4" fontWeight="bold" align="center">
      
    </Typography>
    <AudioPlayerCard/>
    <br/>
    <Box
          sx={{
            backgroundImage: 'url("/images/illimani.jpeg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderRadius: '24px',
            p: { xs: 3, md: 5 },
            m: 'auto',
            maxWidth: 900,
            color: 'white',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {/* Capa oscura encima para contraste */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.45)',
              borderRadius: '24px',
              zIndex: 1,
            }}
          />
    
          <Box sx={{ position: 'relative', zIndex: 2 }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              “CHUKUTA DE COMUNICACIONES”
            </Typography>
            <Typography>
              Aquí puedes insertar el texto que desees. Esta tarjeta tiene imagen de fondo fija desde /public.
            </Typography>
            <Typography mt={2} fontWeight="bold">
                <Typography variant="body1" paragraph>
                La Ciudad de La Paz, elegida como una de las «7 Ciudades Maravillas del Mundo» por la organización New 7 Wonders, en Bolivia, es la capital administrativa más alta del mundo, ubicada en la meseta del Altiplano de los Andes a más de 3,500 m sobre el nivel del mar. Se extiende hasta la ciudad de El Alto en las zonas altas, con el monte nevado Illimani de fondo, con 6,438 m de altura. Se puede acceder al espectacular entorno de la ciudad a través del sistema de teleférico de la ciudad llamado Mi Teleférico.
                </Typography>

                <Typography variant="body1" paragraph>
                La Paz, también conocida como Chuquiago Marka, ciudad cosmopolita, cuenta con muchos contrastes, pues en ella converge una gran riqueza multicultural por su gente, arquitectura, topografía y tradiciones.
                </Typography>

                <Typography variant="body1" paragraph>
                Desde este sitio turístico nace CHUKUTA DE COMUNICACIONES. “Chukuta” es el término empleado para hacer referencia a los y las habitantes de la ciudad de La Paz. CHUKUTA DE COMUNICACIONES, “radio digital”, nace un 16 de julio de 2020 como un aliciente de vida mientras se vivía la pandemia del COVID-19, dando una compañía en esos momentos difíciles para la humanidad, con programación amena, información nacional e internacional, y contenido deportivo. Tiene una gran variedad de programación local y nacional. Actualmente maneja su operación online.
                </Typography>

                <Typography variant="body1" paragraph>
                CHUKUTA DE COMUNICACIONES Online, emisora que fortalece la identidad de todo un pueblo luchador, también rompe fronteras con una amistad abierta al mundo: el reencuentro con compatriotas que están fuera de Bolivia, en algún punto del mundo.
                </Typography>

                <Typography variant="body1" paragraph>
                CHUKUTA DE COMUNICACIONES Online también es música boliviana, con una mezcla de diferentes influencias culturales. Pero también podrás escuchar música internacional en distintos géneros.
                </Typography>

                <Typography fontWeight="bold" mt={2}>
                Con cariño: Lic. Raúl Callisaya Morales
                </Typography>

            </Typography>
          </Box>
    </Box>
  </Box>
);

export default Inicio;